import type { Axios } from 'axios';
import type { InjectionKey } from 'vue';
import type { IStyleProvider } from '@/types';

export const AXIOS = Symbol() as InjectionKey<Axios>;
export const STYLE = Symbol() as InjectionKey<IStyleProvider>;
